import axios from "axios";
import store from "@/store/store";

const rutaApi = store.getters.VUE_APP_ROOT_API;

export default {
  // get() {
  //   return axios.get(rutaApi);
  // },
  // create(todo) {
  //   return axios.post(rutaApi, todo);
  // },
  async get(url, parameters) {
    try {
      const response = await axios.get(rutaApi + url, {
        params: parameters
      });
      return response;
    } catch (error) {
      if (error.response != undefined && error.response.status == 401) {
        alert("Su sesión ha finalizado!");
        // this.$router.push("/");
        window.location.href = "/";
      } else console.error("Error " + error.message + " - GET " + url);
      return Promise.reject(error);
    }
  },
  async post(url, parameters) {
    try {
      const response = await axios.post(rutaApi + url, parameters);
      return response;
    } catch (error) {
      if (error.response != undefined && error.response.status == 401) {
        alert("Su sesión ha finalizado!");
        // this.$router.push("/");
        window.location.href = "/";
      } else console.error("Error " + error.response.status + " - POST " + url);
      return Promise.reject(error);
    }
  },
  async delete(url, parameters) {
    try {
      const response = await axios.delete(rutaApi + url, {
        params: parameters
      });
      return response;
    } catch (error) {
      if (error.response != undefined && error.response.status == 401) {
        alert("Su sesión ha finalizado!");
        // this.$router.push("/");
        window.location.href = "/";
      } else console.error("Error " + error.response.status + " - GET " + url);
      return Promise.reject(error);
    }
  },
  async getBlob(url, parameters) {
    try {
      const response = await axios.get(rutaApi + url, {
        params: parameters,
        responseType: "blob"
      });
      return response;
    } catch (error) {
      if (error.response != undefined && error.response.status == 401) {
        alert("Su sesión ha finalizado!");
        // this.$router.push("/");
        window.location.href = "/";
      } else console.error("Error " + error.response.status + " - GET " + url);
      return Promise.reject(error);
    }
  }
};
